<template>
	<ul>
		<li v-if="items.length === 0">Alles möglich</li>
		<template v-else>
			<li
				v-for="item in items"
				:key="item.id"
				:class="{'has-supplements': hasSupplements(item)}"
			>
				<span class="job-display--box-label">
					<Label :characteristic="item.item" label-type="application" />
				</span>
				<span v-if="hasSupplements(item)" class="job-display--box-supplements">
					<span
						v-for="supplement in item.supplements"
						:key="supplement.characteristicType.id"
					>
						{{ getSupplementsList(supplement.items) }}
					</span>
				</span>
			</li>
		</template>
	</ul>
</template>
<script>
import Label from "@/vue/characteristic/Label";
import {get} from "@/helper/characteristic/Label";
import _ from "lodash";

export default {
	components: {
		Label
	},

	props: {
		items: {
			type: Array,
			required: true,
		},
	},

	methods: {
		hasSupplements (item)
		{
			return item.supplements && item.supplements.length > 0;
		},
		getSupplementsList (items)
		{
			return _.map(
				items,
				item => get(item.item)
			).join(', ');
		}
	},
}
</script>
